import React from 'react';
import { PLACEHOLDER_METRICS } from '../data/content';
import ScrollReveal from '../components/ScrollReveal';
import AnimatedCounter from '../components/AnimatedCounter';

/* ==================================================================
   Metrics
   ------------------------------------------------------------------
   Counters that run once on entry. Values arrive as a prop: whatever
   the platform can prove is real comes from GET /api/stats, and
   anything still unverified stays flagged `placeholder` and keeps the
   footnote visible. Nothing here invents a number quietly.
   ================================================================== */

export default function Metrics({ metrics = PLACEHOLDER_METRICS }) {
  return (
    <section className="hs-metrics" aria-label="HyrSkill in numbers">
      <span className="hs-metrics__glow" aria-hidden="true" />
      <div className="hs-shell">
        <header className="hs-metrics__head">
          <ScrollReveal as="p" className="hs-eyebrow">By the numbers</ScrollReveal>
          <ScrollReveal as="h2" className="hs-h2" delay={80}>
            HyrSkill in numbers
          </ScrollReveal>
        </header>

        <div className="hs-metrics__grid">
          {metrics.map((metric, i) => (
            <ScrollReveal key={metric.id} className="hs-metric" delay={i * 110} variant="up">
              <p className="hs-metric__value">
                <AnimatedCounter value={metric.value} suffix={metric.suffix} />
              </p>
              <p className="hs-metric__label">{metric.label}</p>
              <p className="hs-metric__note">{metric.note}</p>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
